import { useCallback, useState } from 'react';
import { FormikConfig } from 'formik/dist/types';
import { updateUserPassword } from 'shared/modules/user/actions';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import { Button, Typography } from '@mui/material';
import SettingsItem from 'shared/_ui/settings-item';
import SettingsConfirmPasswordDialog from 'shared/_model/settings/settings-confirm-password-dialog';

type TChangePasswordValues = { passwordConfirm: string; password: string };

function Controls({ toggleOpen }: { toggleOpen: () => void }) {
	return (
		<Button variant="outlined" onClick={toggleOpen}>
			Update
		</Button>
	);
}

export default function SettingsChangePassword() {
	const [isOpen, setOpen] = useState(false);

	const handleSubmit = useCallback<FormikConfig<TChangePasswordValues>['onSubmit']>(
		async ({ passwordConfirm, password }, { resetForm }) => {
			if (!!passwordConfirm && !!password) {
				await updateUserPassword({ newPassword: passwordConfirm, password });
			}

			setOpen(false);
			resetForm();
		},
		[]
	);

	const formik = useFormik<TChangePasswordValues>({
		initialValues: { passwordConfirm: '', password: '' },
		validationSchema: object().shape({
			password: string().required('Required'),
			passwordConfirm: string().required('Required'),
		}),
		enableReinitialize: true,
		onSubmit: handleSubmit,
	});
	const { resetForm } = formik;

	const toggleOpen = useCallback(() => {
		resetForm();
		setOpen((s) => !s);
	}, [resetForm]);

	return (
		<SettingsItem control={<Controls toggleOpen={toggleOpen} />}>
			<div>
				<Typography
					variant="h4"
					sx={{
						fontSize: '0.875rem',
					}}
				>
					Change Password
				</Typography>
				<Typography color="secondary">Update your account password</Typography>
			</div>
			{isOpen && <SettingsConfirmPasswordDialog formik={formik} toggleOpen={toggleOpen} />}
		</SettingsItem>
	);
}
